import Vue from 'vue'
export default {
  getDoctorsSlots (doctorType, month, year) {
    return Vue.http.get(window.API_URL + 'doctors/doctor_rosters?roster_type=' + doctorType + '&month=' + month + '&year=' + year)
  },
  getDoctorsList () {
    return Vue.http.get(window.API_URL + 'doctors/doctor_rosters/family_doctors')
  },
  updateSlot (data) {
    return Vue.http.post(window.API_URL + 'doctors/doctor_rosters/bulk_update', {roster: data})
  },
  uploadRoster (data) {
    return Vue.http.post(window.API_URL + 'doctors/doctor_rosters/', data)
  },
  getDoctorChatSlots (month, year) {
    return Vue.http.get(window.API_URL + 'doctors/doctor_chat_availabilities?month=' + month + '&year=' + year)
  },
  updateChatSlot (data) {
    return Vue.http.post(window.API_URL + 'doctors/doctor_chat_availabilities/bulk_update', data)
  },
  uploadChatAvailability (data) {
    return Vue.http.post(window.API_URL + 'doctors/doctor_chat_availabilities/', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/doctor_roster.js